import classnames from 'classnames';
import { AttachmentsModel } from '@/stores/mailEditorStore';
import AttachmentIcon from '@/common/base/attachment-icon';

/**
 * 格式化小数，保留指定小数位，末尾的0不展示
 * @example toFixed(1.001, 2) => 1
 * @param num 需格式化的数字
 * @param figure 需要保留的小数位
 * @returns {number}
 */
export const toFixed = (num: number, figure: number = 0): number => {
  const base = Math.pow(10, figure);
  return Math.round(num * base) / base;
};

/**
 * 格式化文件大小
 * @param size
 * @param base
 * @returns {string}
 */
export const formatFileSize = (size: number, base: number = 1024): string => {
  if (typeof size !== 'number') {
    return '';
  }
  let baseSize = Math.pow(base, 3);
  if (size >= baseSize) {
    return toFixed(size / baseSize, 1) + 'G';
  }
  baseSize /= base;
  if (size >= baseSize) {
    return toFixed(size / baseSize, 1) + 'M';
  }
  baseSize /= base;
  if (size >= baseSize) {
    return toFixed(size / baseSize, 1) + 'K';
  }
  return toFixed(size, 1) + 'B';
};

interface Props extends AttachmentsModel {
  onDelete: () => void; // 删除回调
  reUpload: () => void; // 失败后重传
}

// 附件卡片
const AttachmentCard = (prop: Props) => {
  const {
    fileName,
    fileSize,
    // type,
    // downloadUrl,
    // expireTime,
    // identity,
    onDelete,
    reUpload,
    status,
  } = prop;

  return (
    <>
      <style>
        {`
          @keyframes widthAnimation {
            from {
              width: 7%;
            }
            to {
              width: 95%;
            }
          }
        `}
      </style>
      <div
        className={classnames(
          'flex-[0_0_250px] w-[250px] inline-flex justify-center items-center h-9 py-2.5 px-3 rounded border-[0.5px] border-[#D4D4D4] bg-white relative group',
          { 'border-[#FE5B4C]': status === 'failed' }
        )}
      >
        <AttachmentIcon name={fileName} size={18} />
        <div
          className="flex-[1_1_auto] overflow-hidden text-[#262A33] text-ellipsis  text-xs font-normal ml-1 whitespace-nowrap"
          title={fileName}
        >
          {fileName}
        </div>
        <div className="max-w-[42px] w-[42px] text-[#9FA2AD]  text-xs font-normal ml-1.5 group-hover:hidden">
          {formatFileSize(fileSize)}
        </div>
        {/* 失败后重新上传 */}
        {status === 'failed' && (
          <div
            className="hidden group-hover:inline-block text-[#2563EB] flex-[0_0_32px] w-8 text-center cursor-pointer  text-xs font-medium ml-1.5"
            onClick={() => {
              if (reUpload) reUpload();
            }}
          >
            Retry
          </div>
        )}
        <div
          className="hidden group-hover:inline-block text-[#2563EB] flex-[0_0_39px] w-[39px] text-center cursor-pointer  text-xs font-medium ml-1.5"
          onClick={() => {
            if (onDelete) onDelete();
          }}
        >
          Delete
        </div>
        {/* 上传中 */}
        {status === 'uploading' && (
          <div
            className="absolute left-0 -bottom-px h-0 border-b border-[#3B82F6]"
            style={{
              animation: 'widthAnimation 3s forwards',
            }}
          />
        )}
        {/* 排队中 */}
        {status === 'waiting' && <div className="absolute left-0 w-[7%] -bottom-px h-0 border-b border-[#3B82F6]" />}
      </div>
    </>
  );
};

export default AttachmentCard;
